import {
  RequestRecoveryCodeRequest,
  RequestRecoveryCodeResponse,
  ValidateRecoveryCodeRequest,
  ValidateRecoveryCodeResponse,
  ResetPasswordRequest,
} from '../../../domain/models/session/recovery.model';


export const recoverySdkMock = {
  generateVerificationToken(payload: RequestRecoveryCodeRequest): RequestRecoveryCodeResponse {
    const expiresAt = new Date(Date.now() + 15 * 60 * 1000).toISOString();

    return {
      message: 'Código de verificación enviado a su correo.',
      expiresAt,
    };
  },

  validateVerificationToken(payload: ValidateRecoveryCodeRequest): ValidateRecoveryCodeResponse {
    return {
      valid: true,
      userId: 1,
    };
  },

  resetPassword(payload: ResetPasswordRequest): void {
  },
};
